import * as Y from 'yjs';
import { canvasRoots, type CanvasBinding, TOP_LEVEL_BINDING } from '../wiring/canvas-roots';

/**
 * Sets `edge.locked` (top-level) inside a single transaction tagged
 * with the clientId so per-user undo tracks it. Bumps `updatedAt`.
 * No-ops silently if the edge doesn't exist.
 */
export function setEdgeLocked(
  doc: Y.Doc,
  clientId: number,
  edgeId: string,
  locked: boolean,
  binding: CanvasBinding = TOP_LEVEL_BINDING,
): void {
  doc.transact(() => {
    const edge = canvasRoots(doc, binding).edges.get(edgeId);
    if (!edge) return;
    edge.set('locked', locked);
    edge.set('updatedAt', Date.now());
  }, clientId);
}
